function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_Contat_Us_27-Phone_4211855",
  transform: "translate(-9.689 -9.691)"
}, React.createElement("path", {
  id: "Path_350",
  "data-name": "Path 350",
  d: "M21.107,18.562l-1.742-1.217a1.344,1.344,0,0,0-1.873.333l-.4.58a14.982,14.982,0,0,1-2.155-1.81,14.963,14.963,0,0,1-1.81-2.155l.579-.4a1.343,1.343,0,0,0,.333-1.873l-1.217-1.742a1.346,1.346,0,0,0-1.1-.581,1.261,1.261,0,0,0-.438.078,2.412,2.412,0,0,0-.453.222l-.241.169a1.824,1.824,0,0,0-.17.152,2.416,2.416,0,0,0-.619,1.1c-.5,1.88.741,4.722,3.091,7.073,1.974,1.974,4.345,3.2,6.188,3.2h0a3.433,3.433,0,0,0,.885-.109,2.416,2.416,0,0,0,1.1-.619,1.83,1.83,0,0,0,.159-.18l.17-.242a2.422,2.422,0,0,0,.215-.441A1.323,1.323,0,0,0,21.107,18.562Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 11.999,
    viewBox: "0 0 12 11.999"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/contact.87a02a4d.svg";
export { SvgComponent as ReactComponent };